function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_228",
  "data-name": "Grupo 228",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_16",
  "data-name": "Elipse 16",
  cx: 41.623,
  cy: 41.623,
  r: 41.623,
  transform: "translate(0.039)",
  fill: "#4794fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_89",
  "data-name": "Trazado 89",
  d: "M2548.553,2702.108v-.017a19.824,19.824,0,0,1-1.521-2.529,80.765,80.765,0,0,1-19.47-21.817l0,0c-.4-.652-.8-1.326-1.191-2a118.1,118.1,0,0,1-12.961-34.613q-.721-3.241-1.3-6.675a41.616,41.616,0,1,0,39.72,73.142q.654-.354,1.3-.734a21.159,21.159,0,0,1-4.579-4.755Z",
  transform: "translate(-2490.352 -2629.395)",
  fill: "#275ed4"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_17",
  "data-name": "Elipse 17",
  cx: 35.22,
  cy: 35.22,
  r: 35.22,
  transform: "translate(6.443 6.404)",
  fill: "#69a9f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_90",
  "data-name": "Trazado 90",
  d: "M2652.11,2671.833a1.6,1.6,0,0,1-1.6-1.6v-3.2a1.6,1.6,0,1,1,3.2,0v3.2A1.6,1.6,0,0,1,2652.11,2671.833Z",
  transform: "translate(-2610.448 -2652.622)",
  fill: "#4794fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_91",
  "data-name": "Trazado 91",
  d: "M2700.109,2685.98a1.6,1.6,0,0,1-1.385-2.4l1.6-2.773a1.6,1.6,0,1,1,2.773,1.6h0l-1.6,2.773A1.6,1.6,0,0,1,2700.109,2685.98Z",
  transform: "translate(-2646.44 -2663.551)",
  fill: "#4794fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_92",
  "data-name": "Trazado 92",
  d: "M2566.333,2719.574a80.773,80.773,0,0,1-19.471-21.818h0c-.4-.652-.8-1.328-1.19-2a118.082,118.082,0,0,1-12.961-34.613,35.209,35.209,0,0,0,35.139,60.979v-.016a19.894,19.894,0,0,1-1.521-2.53Z",
  transform: "translate(-2509.653 -2649.407)",
  fill: "#4794fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_93",
  "data-name": "Trazado 93",
  d: "M2735.249,2724.631a1.6,1.6,0,0,1-.8-2.988l2.773-1.6a1.6,1.6,0,0,1,1.6,2.773l-2.773,1.6A1.594,1.594,0,0,1,2735.249,2724.631Z",
  transform: "translate(-2672.788 -2693.413)",
  fill: "#4794fb"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_93",
  "data-name": "Grupo 93",
  transform: "translate(12.846 26.414)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_94",
  "data-name": "Trazado 94",
  d: "M2652.11,2876.633a1.6,1.6,0,0,1-1.6-1.6v-3.2a1.6,1.6,0,0,1,3.2,0v3.2A1.6,1.6,0,0,1,2652.11,2876.633Z",
  transform: "translate(-2623.294 -2832.608)",
  fill: "#275ed4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_95",
  "data-name": "Trazado 95",
  d: "M2597.708,2863.341a1.6,1.6,0,0,1-1.385-2.4l1.6-2.773a1.6,1.6,0,0,1,2.774,1.6l-1.6,2.773a1.6,1.6,0,0,1-1.388.8Z",
  transform: "translate(-2582.501 -2822.961)",
  fill: "#275ed4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_96",
  "data-name": "Trazado 96",
  d: "M2557.886,2827.031a1.6,1.6,0,0,1-.8-2.987l2.773-1.6a1.6,1.6,0,0,1,1.6,2.773l-2.774,1.6A1.6,1.6,0,0,1,2557.886,2827.031Z",
  transform: "translate(-2552.638 -2796.613)",
  fill: "#275ed4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_97",
  "data-name": "Trazado 97",
  d: "M2546.512,2777.431h-3.2a1.6,1.6,0,1,1,0-3.2h3.2a1.6,1.6,0,1,1,0,3.2Z",
  transform: "translate(-2541.71 -2760.622)",
  fill: "#275ed4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_98",
  "data-name": "Trazado 98",
  d: "M2560.656,2724.631a1.593,1.593,0,0,1-.8-.215l-2.773-1.6a1.6,1.6,0,1,1,1.6-2.773l2.773,1.6a1.6,1.6,0,0,1-.8,2.988Z",
  transform: "translate(-2552.637 -2719.827)",
  fill: "#275ed4"
})), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_99",
  "data-name": "Trazado 99",
  d: "M2599.313,2685.98a1.6,1.6,0,0,1-1.388-.8l-1.6-2.773a1.6,1.6,0,1,1,2.773-1.6l1.6,2.773a1.6,1.6,0,0,1-1.385,2.4Z",
  transform: "translate(-2569.655 -2663.551)",
  fill: "#4794fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_100",
  "data-name": "Trazado 100",
  d: "M2629.775,2731.03a1.6,1.6,0,0,0-3.2,0v10.544l-7.535,7.535a1.6,1.6,0,0,0,2.264,2.264l8-8a1.625,1.625,0,0,0,.47-1.133Z",
  transform: "translate(-2586.511 -2700.613)",
  fill: "#e81687"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_101",
  "data-name": "Trazado 101",
  d: "M2623.659,2798.967l-2.417,2.417a1.608,1.608,0,0,1-2.274-2.273l2.994-2.994C2622.507,2797.094,2623.083,2798.039,2623.659,2798.967Z",
  transform: "translate(-2586.448 -2750.62)",
  fill: "#a70b5a"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_18",
  "data-name": "Elipse 18",
  cx: 20.812,
  cy: 20.812,
  r: 20.812,
  transform: "translate(54.47 40.022)",
  fill: "#01033a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_102",
  "data-name": "Trazado 102",
  d: "M2732.973,2831.3h-.018a41.842,41.842,0,0,1-18.008-23.293,52.356,52.356,0,0,1-1.521-6.068,20.8,20.8,0,0,0,25.07,32.355A48.768,48.768,0,0,1,2732.973,2831.3Z",
  transform: "translate(-2653.641 -2754.987)",
  fill: "#040527"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_19",
  "data-name": "Elipse 19",
  cx: 16.009,
  cy: 16.009,
  r: 16.009,
  transform: "translate(59.273 44.825)",
  fill: "#064382"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_103",
  "data-name": "Trazado 103",
  d: "M2780.111,2827.034a1.6,1.6,0,0,0,1.6-1.6v-.234a4.56,4.56,0,0,0-3.2-4.337v-.232a1.6,1.6,0,1,0-3.2,0v.232a4.552,4.552,0,0,0-.676,8.424l3.121,1.561a1.367,1.367,0,0,1-.611,2.59h-.467a1.37,1.37,0,0,1-1.367-1.368v-.233a1.6,1.6,0,0,0-3.2,0v.233a4.561,4.561,0,0,0,3.2,4.337v.232a1.6,1.6,0,1,0,3.2,0v-.232a4.552,4.552,0,0,0,.675-8.424l-3.12-1.561a1.367,1.367,0,0,1,.611-2.59h.467a1.369,1.369,0,0,1,1.368,1.367v.234A1.6,1.6,0,0,0,2780.111,2827.034Z",
  transform: "translate(-2701.628 -2767.801)",
  fill: "#e81687"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_104",
  "data-name": "Trazado 104",
  d: "M2747.366,2849.5a15.4,15.4,0,0,1-4.047.519,16.013,16.013,0,0,1-13.977-23.822A41.847,41.847,0,0,0,2747.366,2849.5Z",
  transform: "translate(-2668.037 -2773.176)",
  fill: "#01033a"
}));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96.094,
    height: 83.254,
    viewBox: "0 0 96.094 83.254",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.06ef8b88.svg";
export { ForwardRef as ReactComponent };